import { AIR_ONLY, CRUISE, HOTEL_ONLY, PACKAGE } from '@/constants';

export const PromosEnum = {
  sectionPromoType: {
    PROMO_BOX_TITLE_EN: 'PROMO_BOX_TITLE_EN',
    PROMO_BOX_TITLE_FR: 'PROMO_BOX_TITLE_FR',
    SIDE_PROMO_TITLE_EN: 'SIDE_PROMO_TITLE_EN',
    SIDE_PROMO_TITLE_FR: 'SIDE_PROMO_TITLE_FR',
    ACCORDION_PROMO_TITLE_EN: 'ACCORDION_PROMO_TITLE_EN',
    ACCORDION_PROMO_TITLE_FR: 'ACCORDION_PROMO_TITLE_FR',
    SURFACE_PROMO_TITLE_EN: 'SURFACE_PROMO_TITLE_EN',
    SURFACE_PROMO_TITLE_FR: 'SURFACE_PROMO_TITLE_FR'
  },
  promotionType: {
    TOP_BANNER: 'TOP_BANNER',
    SIDE_PROMOS: 'SIDE_PROMOS',
    PROMO_BOXES: 'PROMO_BOXES',
    FORM_PROMOS: 'FORM_PROMOS',
    SURFACE_PROMO: 'SURFACE_PROMO',
    ACCORDITION_PROMOS: 'ACCORDION_PROMOS',
    HOME_PAGE_PROMO: 'ACCORDION_PROMOS'
  },
  path: {
    TOP_BANNER: 'top-banners',
    SIDE_PROMOS: 'side-promos',
    PROMO_BOXES: 'promo-boxes',
    FORM_PROMOS: 'form-promos',
    SURFACE_PROMO: 'surface-promos',
    ACCORDITION_PROMOS: 'accordion-promos'
  },
  quoteType: {
    Packages: PACKAGE,
    Hotel: HOTEL_ONLY,
    Airs: AIR_ONLY,
    Cruises: CRUISE
  },
  screenURL: {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
    TABLET: 'tablet',
    WIDESCREEN: 'widescreen'
  },
  lang: {
    ENG: 'en',
    FR: 'fr'
  },
  quoteTypeFormPromo: {
    Packages: PACKAGE,
    Hotel: HOTEL_ONLY,
    Air: AIR_ONLY,
    Cruises: CRUISE
  }
};
